exports = module.exports = require("./../../../../react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "dl{padding:1em 0}dd,dt{margin:0;padding-top:8px;float:left}dt{color:#bbb;width:25%;clear:left}dd{width:70%;padding-left:5%;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/react-scripts/~/css-loader!./~/less-loader/dist/cjs.js!./src/css/component-detail.less
// module id = 738
// module chunks = 0